import { useNavigate } from "react-router-dom";

import styles from "./Home.module.css";

import homepageImageFundars from "../utils/img/homepage-fundars.png";
import homepageImage1 from "../utils/img/homepage-1.png";
import homepageImage2 from "../utils/img/homepage-2.png";

import ProductIcon from "../../../components/ProductIcon";

import { loadStripe } from "@stripe/stripe-js";
import { Box } from "@chakra-ui/react";

// TEST
// const stripePromise = loadStripe(
//   "pk_test_51QwogSLbZvUnMrGq1DijD23ddx09SrHykqV4ZVmleQzRVyxnwiO2As3OvQstMpjP8g1N1Ipe2KjT4lO4MgjWHf1q00xCKmDjp4"
// );
// REAL
const stripePromise = loadStripe(
  "pk_live_51QwogSLbZvUnMrGqGDv2sK47uxv1h9QS2m77yQmGVpSl5fgk46RM1tYrhOL0Pi7JJzsNRCS8AIi6ZOTwEl7NwsUP00DfFSVybY"
);

function Home({}) {
  const navigate = useNavigate();

  return (
    <>
      {/* <div className={styles.section}>
        <div className={styles.containerHeader}>
          <h1>Soluções para Engenharia Civil na palma da sua mão</h1>
          <p>
            Sem precisar instalar nada utilize nossas ferramentas para resolver
            problemas do seu dia a dia, confira alguns dos benefícios das nossas
            ferramentas
          </p>
          <div className={styles.headerCards}>
            <div className={styles.headerCard}>Acesso online facilitado</div>
            <div className={styles.headerCard}>
              Interface agradável e intuitiva
            </div>
            <div className={styles.headerCard}>Ferramentas modernas</div>
            <div className={styles.headerCard}>Constantemente incrementada</div>
            <div className={styles.headerCard}>
              Exportação de tabelas e relatórios
            </div>
          </div>
        </div>
      </div> */}
      <div className={styles.section}>
        <div className={styles.productLandpage}>
          <div className={styles.softwaresText}>
            <h1>FundArs</h1>
            <p>
              Aumente sua produtividade com a solução definitiva para o cálculo
              de estacas.
            </p>
            <p>
              Crie sua conta e comece a utilizar o Fundars de maneira gratuita!
            </p>
            {/* <ProductIcon product="fundars" /> */}
            <button
              className={styles.homepageButtonBig}
              onClick={() => navigate("/login")}
            >
              EXPERIMENTE GRATUITAMENTE
            </button>
            <button
              className={styles.homepageButtonBig}
              onClick={() => navigate("/assinaturas")}
            >
              CONHEÇA OS PLANOS
            </button>
            <video className="background-video" autoPlay loop muted playsInline>
              <source src="/0816.MP4" type="video/mp4" />
              Seu navegador não suporta vídeo HTML5.
            </video>
          </div>
        </div>
      </div>
      <div
        className={styles.section}
        style={{
          backgroundColor: "var(--background-dark-color)",
        }}
      >
        <div className={styles.containerCalculators}>
          <div className={styles.calculatorsText}>
            <h1>Calculadoras</h1>
            <p>
              Faça verificações rápidas com uma interface simplificada e
              direcionada para o seu problema
            </p>
            <button
              className={styles.homepageButton}
              onClick={() => navigate("/calculadoras")}
            >
              SAIBA MAIS
            </button>
          </div>
          <img className={styles.calculatorsImage} src={homepageImage1}></img>
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.containerSoftwares}>
          <div className={styles.softwaresText}>
            <h1>Programas</h1>
            <p>
              Soluções completas para resolução de problemas maiores, com
              integração do começo ao fim da solução
            </p>
            <button
              className={styles.homepageButton}
              onClick={() => navigate("/programas")}
            >
              SAIBA MAIS
            </button>
          </div>
          <img className={styles.softwaresImage} src={homepageImage2}></img>
        </div>
      </div>
      <div
        className={styles.section}
        style={{ backgroundColor: "var(--background-dark-color)" }}
      >
        <div className={styles.containerOthers}>
          <div className={styles.othersText}>
            <h1>Guia básico</h1>
            <p>Está com dificuldade em utilizar as nossas ferramentas?</p>
            <p>
              Pensando nisso desenvolvemos um tutorial completo para cada
              ferramenta
            </p>
          </div>
          <div className={styles.othersText}>
            <h1>Transparência</h1>
            <p>
              Acompanhe o que está sendo desenvolvido pela nossa equipe desde
              melhorias para as nossas ferramentas até novas ferramentas que
              serão adicioandas!
            </p>
          </div>
          <div className={styles.othersText}>
            <h1>Participe do desenvovimento</h1>
            <p>
              Possui alguma sugestão de melhoria ou gostaria de reportar algum
              erro que encontrou?
            </p>
            <p>Estamos abertos a todo e qualquer tipo de feedback</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
